import { render, staticRenderFns } from "./CreateCompanyAccount.vue?vue&type=template&id=16868594&scoped=true"
import script from "./CreateCompanyAccount.vue?vue&type=script&lang=js"
export * from "./CreateCompanyAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyAccount.vue?vue&type=style&index=0&id=16868594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16868594",
  null
  
)

export default component.exports